// Mapeo Índice de Silicio (0-100) → color del avatar.
// Interpolación HSL para transiciones suaves entre tiers — ningún tripulante
// queda en el límite de un tier sin sentir el matiz vecino.

import * as THREE from "three"

const STOPS: Array<[number, string]> = [
    [0, "#FF3D55"], // Entropía Absoluta
    [25, "#FF8C42"], // Resistencia
    [50, "#D4AF37"], // Punto Neutro
    [75, "#9DE5FF"], // Ligereza
    [100, "#00E5FF"], // Fricción Cero
]

const cache = new Map<number, string>()

export function siliconColor(index: number): string {
    const i = Math.round(Math.max(0, Math.min(100, index)))
    const cached = cache.get(i)
    if (cached) return cached

    let result = STOPS[STOPS.length - 1][1]
    for (let s = 0; s < STOPS.length - 1; s++) {
        const [aIdx, aColor] = STOPS[s]
        const [bIdx, bColor] = STOPS[s + 1]
        if (i >= aIdx && i <= bIdx) {
            const t = (i - aIdx) / (bIdx - aIdx)
            const a = new THREE.Color(aColor)
            const b = new THREE.Color(bColor)
            const mixed = a.clone().lerpHSL(b, t)
            result = `#${mixed.getHexString()}`
            break
        }
    }
    cache.set(i, result)
    return result
}

export function siliconIntensity(index: number): number {
    // Más alto = más brillo, más glow del bloom.
    const i = Math.max(0, Math.min(100, index))
    return 0.6 + (i / 100) * 1.4 // rango 0.6 → 2.0
}
